import './index.sass';
import axios from "axios";
import 'swiped-events/dist/swiped-events.min';
import {throttle} from "lodash-es";

export default () => {
  $('.js-notifi-unfollow').on('click', function(e) {
    e.preventDefault();
    let url = $(this).attr('href');
    axios({
      url: url,
      method: 'DELETE',
      headers: {"X-CSRF-Token": $('meta[name=csrf-token]').attr('content')}
    }).then((response) => {
      document.location.reload();
    });
  })

  const handleLeftSwipe = (e) => {
    if(e.target.closest('.notification-item')) {
      $(e.target).closest('.notification-item.follow').addClass('notification-item--swiped');
    }
  }

  const handleRightSwipe = (e) => {
    if(e.target.closest('.notification-item')) {
      $(e.target).closest('.notification-item.follow').removeClass('notification-item--swiped');
    }
  }

  const initSwipe = () => {
    if (window.innerWidth <= 768) {
      document.addEventListener('swiped-left', handleLeftSwipe);
      document.addEventListener('swiped-right', handleRightSwipe);
    } else {
      document.removeEventListener('swiped-left', handleLeftSwipe);
      document.removeEventListener('swiped-right', handleRightSwipe);
    }
  }
  initSwipe();
  $(window).on('resize', throttle(() => initSwipe(),250));

}